<!-- Loading Indicator -->
@if (shwLdr) {
<ds-loading></ds-loading>
}

<!-- Edit Trip Slide-Over Panel (Tailwind CSS) -->
@if (openEditTripSlider) {
<div class="fixed inset-0 z-50 overflow-hidden">
  <!-- Backdrop -->
  <div
    class="absolute inset-0 bg-gray-500 bg-opacity-50 transition-opacity"
    (click)="closeEditTripDrawer()"
  ></div>
  <!-- Slide-over panel -->
  <div class="fixed inset-y-0 right-0 flex max-w-full pl-10">
    <div
      class="w-screen max-w-md transform transition-transform duration-300 ease-in-out"
      [class.translate-x-0]="openEditTripSlider"
      [class.translate-x-full]="!openEditTripSlider"
    >
      <div class="flex h-full flex-col bg-white shadow-2xl">
        <!-- Header -->
        <div class="bg-gradient-to-r from-blue-600 to-indigo-600 px-4 py-4">
          <div class="flex items-center justify-between">
            <h2 class="text-lg font-semibold text-white">Edit Trip Details</h2>
            <button
              type="button"
              (click)="closeEditTripDrawer()"
              class="rounded-md text-white hover:text-gray-200 focus:outline-none"
            >
              <svg
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
        <!-- Content -->
        @if (selectedTripForEdit) {
        <div class="flex-1 overflow-y-auto px-4 py-4">
          <div class="space-y-4">
            <!-- Trip Info Card -->
            <div class="rounded-lg border border-slate-200 bg-slate-50 p-3">
              <div class="flex items-center gap-3">
                <div
                  class="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center text-blue-600"
                >
                  <svg
                    class="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                    />
                  </svg>
                </div>
                <div>
                  <p
                    class="text-[11px] uppercase tracking-wide text-slate-500 mb-0"
                  >
                    Trip #{{ selectedTripForEdit.trp_sqnc_nu }}
                  </p>
                  <p class="text-base font-semibold text-slate-900 mb-0">
                    {{ selectedTripForEdit.asrt_nm || "No Vehicle" }}
                  </p>
                  <p class="text-xs text-slate-500 mb-0">
                    {{ selectedTripForEdit.asrt_ctgry_nm || "N/A" }}
                  </p>
                </div>
              </div>
            </div>
            <!-- Route Info -->
            <div class="rounded-lg border border-slate-200 bg-white p-3">
              <p class="text-xs font-semibold uppercase text-slate-500 mb-2">
                Route
              </p>
              <div class="flex items-center gap-2 text-sm">
                <span class="font-medium text-slate-800">{{
                  selectedTripForEdit.strt_fnce_nm
                }}</span>
                <svg
                  class="w-4 h-4 text-slate-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                  />
                </svg>
                <span class="font-medium text-slate-800">{{
                  selectedTripForEdit.end_fnce_nm
                }}</span>
              </div>
            </div>
            <!-- Edit Driver -->
            <div class="rounded-lg border border-slate-200 bg-white p-3">
              <p class="text-xs font-semibold uppercase text-slate-500 mb-2">
                <i nz-icon nzType="user" nzTheme="outline" class="mr-1"></i>
                Change Driver
              </p>
              <p class="text-sm text-slate-600 mb-2">
                Current:
                <strong>{{
                  selectedTripForEdit.crw_nm ||
                    "Not
                    Assigned"
                }}</strong>
              </p>
              <nz-select
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Select new driver"
                [(ngModel)]="selectedDriver"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onselectDriver($event, selectedTripForEdit)"
                class="w-full"
              >
                @for (crw of driversLst; track crw) {
                <nz-option
                  [nzValue]="crw.crw_id"
                  [nzLabel]="crw.crw_nm"
                ></nz-option>
                }
              </nz-select>
            </div>
            <!-- Edit Start Time -->
            <div class="rounded-lg border border-slate-200 bg-white p-3">
              <p class="text-xs font-semibold uppercase text-slate-500 mb-2">
                <i
                  nz-icon
                  nzType="clock-circle"
                  nzTheme="outline"
                  class="mr-1"
                ></i>
                Change Start Time
              </p>
              <p class="text-sm text-slate-600 mb-2">
                Current:
                <strong>{{
                  selectedTripForEdit.schdle_strt_tm || "--"
                }}</strong>
              </p>
              <nz-time-picker
                [(ngModel)]="slctdstrt_tm"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onselectStrtTime($event, selectedTripForEdit)"
                [nzUse12Hours]="true"
                [nzFormat]="timeFormat"
                class="w-full"
              ></nz-time-picker>
            </div>
            <!-- Edit End Time -->
            <div class="rounded-lg border border-slate-200 bg-white p-3">
              <p class="text-xs font-semibold uppercase text-slate-500 mb-2">
                <i
                  nz-icon
                  nzType="clock-circle"
                  nzTheme="outline"
                  class="mr-1"
                ></i>
                Change End Time
              </p>
              <p class="text-sm text-slate-600 mb-2">
                Current:
                <strong>{{ selectedTripForEdit.schdle_end_tm || "--" }}</strong>
              </p>
              <nz-time-picker
                [(ngModel)]="slctdend_tm"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onselectEndTime($event, selectedTripForEdit)"
                [nzUse12Hours]="true"
                [nzFormat]="timeFormat"
                class="w-full"
              ></nz-time-picker>
            </div>
            <!-- Edit Vehicle -->
            <div class="rounded-lg border border-slate-200 bg-white p-3">
              <p class="text-xs font-semibold uppercase text-slate-500 mb-2">
                <i nz-icon nzType="car" nzTheme="outline" class="mr-1"></i>
                Change Vehicle
              </p>
              <p class="text-sm text-slate-600 mb-2">
                Current:
                <strong>{{
                  selectedTripForEdit.asrt_nm ||
                    "Not
                    Assigned"
                }}</strong>
              </p>
              <nz-select
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Select new vehicle"
                [(ngModel)]="selectedVhcle"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onselectVeh($event)"
                class="w-full"
              >
                @for (a of vehiclesLst2; track a) {
                <nz-option
                  [nzValue]="a.asrt_id"
                  [nzLabel]="a.asrt_nm"
                ></nz-option>
                }
              </nz-select>
            </div>
          </div>
        </div>
        }
        <!-- Footer -->
        <div class="border-t border-gray-200 px-4 py-3">
          <button
            type="button"
            (click)="closeEditTripDrawer()"
            class="w-full inline-flex justify-center items-center gap-2 rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none"
          >
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
}

<!-- Header Section -->
<div
  class="relative bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 shadow-xl border-b-4 border-blue-200 mb-6 overflow-hidden cstmmrgin"
>
  <div class="absolute inset-0 opacity-5">
    <div
      class="absolute top-0 left-0 w-96 h-96 bg-blue-500 rounded-full blur-3xl"
    ></div>
    <div
      class="absolute bottom-0 right-0 w-96 h-96 bg-indigo-500 rounded-full blur-3xl"
    ></div>
  </div>

  <div class="relative flex items-center justify-between px-8 py-2">
    <div class="flex items-center gap-3">
      <div
        class="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl shadow-lg flex items-center justify-center"
      >
        <svg
          class="w-6 h-6 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
          />
        </svg>
      </div>
      <div>
        <h1
          class="text-xl font-bold bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent mb-0"
        >
          Single Trip Schedule
        </h1>
      </div>
    </div>
    <!-- Back Button - Header Top Right -->
    <button
      type="button"
      (click)="goBackToTripsDashboard()"
      class="inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold text-white bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 cursor-pointer"
    >
      <svg
        class="w-4 h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M10 19l-7-7m0 0l7-7m-7 7h18"
        />
      </svg>
      <span>Back</span>
    </button>
  </div>
  <div
    class="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-400 via-indigo-500 to-purple-500"
  ></div>
</div>

<div class="px-4 md:px-6">
  <!-- Filter Section -->
  <div class="filter-strip-container mb-4">
    <div class="filter-strip expanded">
      <div class="filter-strip-content">
        <div
          class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-3 p-3 bg-white rounded-xl shadow-sm border border-gray-100"
        >
          <form nz-form [formGroup]="topfltrForm" class="contents">
            <!-- ULB/Mandal -->
            @if (!showLbl) {
            <div class="space-y-1">
              <label
                class="filter-label text-xs font-semibold text-slate-600 uppercase tracking-wide"
                >{{ lblNm }}</label
              >
              <nz-select
                nzShowSearch
                nzAllowClear
                [nzPlaceHolder]="'Select ' + lblNm"
                formControlName="tnt_id"
                (ngModelChange)="onTenantChange($event)"
                [(ngModel)]="tnt_id"
                class="w-full"
              >
                @for (t of tntLst; track t) {
                <nz-option
                  [nzValue]="t.tnt_id"
                  [nzLabel]="t.tnt_nm"
                ></nz-option>
                }
              </nz-select>
            </div>
            } @if (showLbl) {
            <div class="space-y-1">
              <label
                class="filter-label text-xs font-semibold text-slate-600 uppercase tracking-wide"
                >{{ lblNm }}</label
              >
              <span class="block text-sm font-medium text-slate-800 py-2">{{
                tntLst[0]?.tnt_nm
              }}</span>
            </div>
            }

            <!-- Trip Type -->
            <div class="space-y-1">
              <label
                class="filter-label text-xs font-semibold text-slate-600 uppercase tracking-wide"
                >Trip Type</label
              >
              <nz-select
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Select Trip Type"
                formControlName="trp_typ_id"
                (ngModelChange)="onTrpTypSelected($event)"
                [(ngModel)]="trp_typ_id"
                class="w-full"
              >
                @for (a of tripTypeLst; track a) {
                <nz-option
                  [nzValue]="a.trp_typ_id"
                  [nzLabel]="a.trp_typ_nm"
                ></nz-option>
                }
              </nz-select>
            </div>

            <!-- Sachivalayam -->
            @if (showSchvlym) {
            <div class="space-y-1">
              <label
                class="filter-label text-xs font-semibold text-slate-600 uppercase tracking-wide"
                >Sachivalayam</label
              >
              <nz-select
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Select Sachivalayam"
                formControlName="slctedSvm_id"
                (ngModelChange)="onsvmgetSelected($event)"
                [(ngModel)]="svm_id"
                class="w-full"
              >
                <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
                @for (a of svmDrpDwnList; track a) {
                <nz-option
                  [nzValue]="a.svm_id"
                  [nzLabel]="a.svm_nm"
                ></nz-option>
                }
              </nz-select>
            </div>
            }

            <!-- Vehicle -->
            <div class="space-y-1">
              <label
                class="filter-label text-xs font-semibold text-slate-600 uppercase tracking-wide"
                >Vehicle</label
              >
              <nz-select
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Select Vehicle"
                formControlName="asrt_id"
                (ngModelChange)="onVehicleSelected($event)"
                [(ngModel)]="asrt_id"
                class="w-full"
              >
                <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
                @for (a of vehiclesLst; track a) {
                <nz-option
                  [nzValue]="a.asrt_id"
                  [nzLabel]="a.asrt_nm"
                ></nz-option>
                }
              </nz-select>
            </div>

            <!-- Material -->
            @if (!showSchvlym) {
            <div class="space-y-1">
              <label
                class="filter-label text-xs font-semibold text-slate-600 uppercase tracking-wide"
                >Material</label
              >
              <nz-select
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Select Material"
                formControlName="mtrl_typ_id"
                (ngModelChange)="onmtrlTypeChnge($event)"
                [(ngModel)]="mtrl_typ_id"
                class="w-full"
              >
                <nz-option [nzLabel]="'ALL'" [nzValue]="0"></nz-option>
                <nz-option [nzLabel]="'Dry Waste'" [nzValue]="1"></nz-option>
                <nz-option [nzLabel]="'Wet Waste'" [nzValue]="2"></nz-option>
              </nz-select>
            </div>
            }

            <!-- Actions -->
            <div class="flex items-end gap-2">
              <button
                nz-button
                nzType="primary"
                type="button"
                class="flex items-center gap-2 rounded-lg"
                (click)="resetAllForms(); getclstrWseRoutLst()"
              >
                <i nz-icon nzType="search" nzTheme="outline"></i> Get Trips
              </button>
              @if (shwRtlst == true || showNoDtls == true) {
              <button
                nz-button
                nzType="default"
                type="button"
                class="flex items-center gap-2 rounded-lg border-emerald-500 text-emerald-600 hover:bg-emerald-50"
                (click)="addNewTrp(); resetAllForms()"
              >
                <i nz-icon nzType="plus" nzTheme="outline"></i> Add Trip
              </button>
              }
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- No Data -->
  @if (showNoDtls == true) {
  <div
    class="bg-white rounded-xl shadow-sm border border-gray-100 p-8 text-center"
  >
    <div
      class="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4"
    >
      <svg
        class="h-8 w-8 text-gray-400"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"
        />
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
        />
      </svg>
    </div>
    <h3 class="text-lg font-semibold text-gray-700 mb-2">No routes found</h3>
    <p class="text-sm text-gray-500">
      No routes are added for selected vehicle(s)
    </p>
  </div>
  }

  <!-- Trips List and Map Section -->
  @if (shwRtlst == true) {
  <div
    class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden mb-6"
  >
    <div class="flex flex-col lg:flex-row" style="height: 600px">
      <!-- Left: Trip Cards -->
      <div
        class="w-full lg:w-1/3 border-r border-gray-200 overflow-y-auto bg-slate-50"
      >
        <div class="p-3">
          <p class="text-sm font-semibold text-slate-600 mb-3">Trip List</p>
          <div class="grid grid-cols-1 gap-3">
            @for (s of clstRtsLst; track s; let i = $index) {
            <!-- Simple Clean Card -->
            <article
              class="flex flex-col justify-between rounded-xl bg-white border border-gray-100 shadow-[0_4px_18px_rgba(0,0,0,0.06)] hover:shadow-[0_8px_24px_rgba(0,0,0,0.12)] transition-all duration-300 hover:-translate-y-1 p-3 gap-3 cursor-pointer w-full"
              tabindex="0"
              [class.ring-2]="s.isSelected"
              [class.ring-blue-500]="s.isSelected"
              [class.shadow-blue-200]="s.isSelected"
              (click)="selectCrd(s)"
            >
              <div class="flex flex-col gap-3 h-full">
                <!-- Top Row: Icon + Vehicle + Trip Badge -->
                <div class="flex items-start justify-between gap-3">
                  <div class="flex items-center gap-3">
                    <div
                      class="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center text-blue-600 shadow-inner"
                    >
                      <svg
                        class="w-6 h-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0zM13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10h10zm0-8h6l3 4v4h-2m0 0a2 2 0 11-4 0"
                        />
                      </svg>
                    </div>
                    <div class="space-y-0.5">
                      <p class="text-base font-semibold text-gray-900 m-0">
                        {{ s.asrt_nm || "No Vehicle" }}
                      </p>
                      <p class="text-xs text-gray-500 m-0">
                        {{ s.asrt_ctgry_nm || "N/A" }}
                      </p>
                      <p class="text-[11px] text-gray-400 m-0">
                        {{ s.trp_typ_nm }}
                      </p>
                    </div>
                  </div>
                  <span
                    class="px-2 py-1 rounded-full bg-blue-100 text-blue-700 text-xs font-bold"
                  >
                    Trip #{{ s.trp_sqnc_nu }}
                  </span>
                </div>
                <!-- Route Info -->
                <div class="flex flex-col gap-1 text-xs text-gray-500">
                  <div class="flex items-center gap-2">
                    <span class="font-semibold uppercase tracking-wide"
                      >Route:</span
                    >
                    <span
                      class="text-sm font-semibold text-gray-800 flex items-center gap-1"
                    >
                      {{ s.strt_fnce_nm }}
                      <svg
                        class="w-4 h-4 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M14 5l7 7m0 0l-7 7m7-7H3"
                        />
                      </svg>
                      {{ s.end_fnce_nm }}
                    </span>
                  </div>
                </div>
                <!-- Show More Details (Collapsible) -->
                @if (isCardExpanded(i)) {
                <div
                  class="border-t border-gray-100 text-xs text-gray-500 animate-fadeIn pt-2 space-y-2"
                >
                  <div class="flex flex-wrap items-center gap-2">
                    <span class="font-semibold uppercase tracking-wide"
                      >Driver:</span
                    >
                    <span class="text-sm font-semibold text-gray-800">{{
                      s.crw_nm || "Not Assigned"
                    }}</span>
                  </div>
                  <!-- Schedule with inline edit -->
                  <div class="flex flex-wrap items-center gap-2">
                    <span class="font-semibold uppercase tracking-wide"
                      >Schedule:</span
                    >
                    <!-- Start Time -->
                    <div class="flex items-center gap-1">
                      @if (!s.shwStrtTmEdt) {
                      <span class="text-sm font-semibold text-gray-800">{{
                        s.schdle_strt_tm || "--"
                      }}</span>
                      } @if (!s.shwStrtTmEdt) {
                      <button
                        type="button"
                        (click)="
                          onStrtTmEdt(s);
                          slctd_trp_schd = s.trp_schde_id;
                          $event.stopPropagation()
                        "
                        class="w-5 h-5 flex items-center justify-center rounded text-blue-500 hover:bg-blue-50 transition"
                        title="Edit Start Time"
                      >
                        <i
                          nz-icon
                          nzType="edit"
                          nzTheme="outline"
                          class="text-[10px]"
                        ></i>
                      </button>
                      }
                      <!-- Start Time Picker (inline) -->
                      @if (s.shwStrtTmEdt) {
                      <div
                        class="flex items-center gap-1"
                        (click)="$event.stopPropagation()"
                      >
                        <nz-time-picker
                          [(ngModel)]="slctdstrt_tm"
                          [ngModelOptions]="{ standalone: true }"
                          (ngModelChange)="onselectStrtTime($event, s)"
                          [nzUse12Hours]="true"
                          [nzFormat]="timeFormat"
                          nzSize="small"
                          class="w-24"
                        ></nz-time-picker>
                        <button
                          type="button"
                          (click)="closeSlct(s); $event.stopPropagation()"
                          class="w-5 h-5 flex items-center justify-center text-gray-400 hover:text-red-500 transition"
                        >
                          <i
                            nz-icon
                            nzType="close"
                            nzTheme="outline"
                            class="text-[10px]"
                          ></i>
                        </button>
                      </div>
                      }
                    </div>
                    <span class="text-gray-400">-</span>
                    <!-- End Time -->
                    <div class="flex items-center gap-1">
                      @if (!s.shwEndTmEdt) {
                      <span class="text-sm font-semibold text-gray-800">{{
                        s.schdle_end_tm || "--"
                      }}</span>
                      } @if (!s.shwEndTmEdt) {
                      <button
                        type="button"
                        (click)="
                          onEndTmEdt(s);
                          slctd_trp_schd = s.trp_schde_id;
                          $event.stopPropagation()
                        "
                        class="w-5 h-5 flex items-center justify-center rounded text-blue-500 hover:bg-blue-50 transition"
                        title="Edit End Time"
                      >
                        <i
                          nz-icon
                          nzType="edit"
                          nzTheme="outline"
                          class="text-[10px]"
                        ></i>
                      </button>
                      }
                      <!-- End Time Picker (inline) -->
                      @if (s.shwEndTmEdt) {
                      <div
                        class="flex items-center gap-1"
                        (click)="$event.stopPropagation()"
                      >
                        <nz-time-picker
                          [(ngModel)]="slctdend_tm"
                          [ngModelOptions]="{ standalone: true }"
                          (ngModelChange)="onselectEndTime($event, s)"
                          [nzUse12Hours]="true"
                          [nzFormat]="timeFormat"
                          nzSize="small"
                          class="w-24"
                        ></nz-time-picker>
                        <button
                          type="button"
                          (click)="closeSlct(s); $event.stopPropagation()"
                          class="w-5 h-5 flex items-center justify-center text-gray-400 hover:text-red-500 transition"
                        >
                          <i
                            nz-icon
                            nzType="close"
                            nzTheme="outline"
                            class="text-[10px]"
                          ></i>
                        </button>
                      </div>
                      }
                    </div>
                  </div>
                  @if (s.svm_nms && showSchvlym) {
                  <div class="flex flex-wrap items-center gap-2">
                    <span class="font-semibold uppercase tracking-wide"
                      >Sachivalayam:</span
                    >
                    <span class="text-sm font-semibold text-gray-800">{{
                      s.svm_nms
                    }}</span>
                  </div>
                  }
                </div>
                }
                <!-- Action Buttons Row -->
                <div
                  class="flex items-center justify-between gap-2 pt-2 border-t"
                >
                  <!-- Left: Show More -->
                  <button
                    type="button"
                    (click)="toggleCardDetails(i, $event)"
                    class="text-xs text-blue-600 hover:text-blue-700 font-medium flex items-center gap-1"
                  >
                    <span>{{ isCardExpanded(i) ? "Less" : "More" }}</span>
                    <svg
                      class="w-3 h-3 transition-transform"
                      [class.rotate-180]="isCardExpanded(i)"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </button>
                  <!-- Right: Action Icons -->
                  <div class="flex items-center gap-1">
                    <!-- Route -->
                    <button
                      type="button"
                      (click)="getRouteOnMap(s); $event.stopPropagation()"
                      class="w-7 h-7 flex items-center justify-center rounded-md border border-blue-200 bg-blue-50 text-blue-600 shadow-sm hover:bg-blue-100 transition"
                      title="View Route"
                    >
                      <i
                        nz-icon
                        nzType="rise"
                        nzTheme="outline"
                        class="text-sm"
                      ></i>
                    </button>
                    <!-- Edit -->
                    <button
                      type="button"
                      (click)="openEditTripDrawer(s, $event)"
                      class="w-7 h-7 flex items-center justify-center rounded-md border border-green-200 bg-green-50 text-green-600 shadow-sm hover:bg-green-100 transition"
                      title="Edit Trip"
                    >
                      <i
                        nz-icon
                        nzType="edit"
                        nzTheme="outline"
                        class="text-sm"
                      ></i>
                    </button>
                    <!-- Vehicle -->
                    <button
                      type="button"
                      (click)="toggleVehicleSelection(s, $event)"
                      class="w-7 h-7 flex items-center justify-center rounded-md border border-purple-200 bg-purple-50 text-purple-600 shadow-sm hover:bg-purple-100 transition"
                      title="Change Vehicle"
                    >
                      <i
                        nz-icon
                        nzType="car"
                        nzTheme="outline"
                        class="text-sm"
                      ></i>
                    </button>
                    <!-- Delete -->
                    <button
                      type="button"
                      (click)="showConfirm(s); $event.stopPropagation()"
                      class="w-7 h-7 flex items-center justify-center rounded-md border border-red-200 bg-red-50 text-red-600 shadow-sm hover:bg-red-100 transition"
                      title="Delete Trip"
                    >
                      <i
                        nz-icon
                        nzType="delete"
                        nzTheme="outline"
                        class="text-sm"
                      ></i>
                    </button>
                  </div>
                </div>
                <!-- Vehicle Selection (Inline Dropdown) -->
                @if (s.shwVhcle) {
                <div class="border-t border-purple-100 pt-3 animate-fadeIn">
                  <div class="flex items-center gap-2">
                    <nz-select
                      nzShowSearch
                      nzAllowClear
                      nzPlaceHolder="Select Vehicle"
                      nzSize="small"
                      (ngModelChange)="onselectVeh($event)"
                      [(ngModel)]="selectedVhcle"
                      class="flex-1"
                    >
                      @for (a of vehiclesLst2; track a) {
                      <nz-option
                        [nzValue]="a.asrt_id"
                        [nzLabel]="a.asrt_nm"
                      ></nz-option>
                      }
                    </nz-select>
                    <button
                      type="button"
                      (click)="closeSlct(s); $event.stopPropagation()"
                      class="w-6 h-6 flex items-center justify-center text-gray-400 hover:text-red-500 transition"
                    >
                      <i
                        nz-icon
                        nzType="close"
                        nzTheme="outline"
                        class="text-xs"
                      ></i>
                    </button>
                  </div>
                </div>
                }
              </div>
            </article>
            }
          </div>
        </div>
      </div>
      <!-- Right: Map -->
      <div class="w-full lg:w-2/3">
        <div id="map" class="w-full h-full"></div>
      </div>
    </div>
  </div>
  }

  <!-- Add Trip Form Section -->
  @if (shwFnceFltr || isAddTrip || shwrtDtls) {
  <div class="space-y-4">
    <!-- Location Filter -->
    @if (shwFnceFltr) {
    <div class="bg-white rounded-xl shadow-sm border border-gray-100 p-4">
      <h2 class="text-base font-semibold text-gray-800 mb-3">
        Select Trip Locations
      </h2>
      <form nz-form [formGroup]="fnceFltrForm">
        <div nz-row [nzGutter]="16">
          <div nz-col nzSpan="12">
            <nz-form-label>Starting Location</nz-form-label>
            <nz-form-item>
              <nz-form-control>
                <nz-select
                  nzShowSearch
                  nzAllowClear
                  nzPlaceHolder="Select Starting Location"
                  formControlName="fnce_id"
                  (ngModelChange)="frmfnceSelected($event)"
                >
                  @for (f of frmfnceFltrOptns; track f) {
                  <nz-option [nzValue]="f" [nzLabel]="f.fnce_nm"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
            <span class="text-xs text-gray-500">{{ frm_fnce_grp_nm }}</span>
          </div>
          <div nz-col nzSpan="12">
            <nz-form-label>Ending Location</nz-form-label>
            <nz-form-item>
              <nz-form-control>
                <nz-select
                  nzShowSearch
                  nzAllowClear
                  nzPlaceHolder="Select Ending Location"
                  formControlName="end_fnce_id"
                  (ngModelChange)="endfnceSelected($event)"
                >
                  @for (f of tofnceFltrOptns; track f) {
                  <nz-option [nzValue]="f" [nzLabel]="f.fnce_nm"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
            <span class="text-xs text-gray-500">{{ end_fnce_grp_nm }}</span>
          </div>
        </div>
        <div class="mt-3 p-3 bg-blue-50 rounded-lg text-sm text-blue-800">
          <a
            (click)="opensideBar('addFncePanel', '')"
            class="text-blue-600 hover:underline cursor-pointer"
            >Click here</a
          >
          to add locations if not in the list.
        </div>
      </form>
    </div>
    }
    <!-- Trip Details Form -->
    @if (isAddTrip) {
    <div class="bg-white rounded-xl shadow-sm border border-gray-100 p-4">
      <h2 class="text-base font-semibold text-gray-800 mb-3">Trip Details</h2>
      <form nz-form [formGroup]="fncTypForm">
        <div nz-row [nzGutter]="16">
          <div nz-col nzSpan="6">
            <nz-form-label>Trip Number</nz-form-label>
            <nz-form-item>
              <nz-form-control>
                <input
                  nz-input
                  type="number"
                  placeholder="Trip Number"
                  formControlName="trp_nu"
                />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzSpan="6">
            <nz-form-label>Driver</nz-form-label>
            <nz-form-item>
              <nz-form-control>
                <nz-select
                  nzShowSearch
                  nzAllowClear
                  nzPlaceHolder="Select Driver"
                  formControlName="crw_id"
                >
                  @for (crw of driversLst; track crw) {
                  <nz-option
                    [nzValue]="crw.crw_id"
                    [nzLabel]="crw.crw_nm"
                  ></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzSpan="6">
            <nz-form-label>Start Time</nz-form-label>
            <nz-form-item>
              <nz-form-control>
                <nz-time-picker
                  nzShowTime
                  formControlName="strt_tm"
                  [nzUse12Hours]="true"
                  [nzFormat]="timeFormat"
                  class="w-full"
                ></nz-time-picker>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzSpan="6">
            <nz-form-label>End Time</nz-form-label>
            <nz-form-item>
              <nz-form-control>
                <nz-time-picker
                  nzShowTime
                  formControlName="end_tm"
                  [nzUse12Hours]="true"
                  [nzFormat]="timeFormat"
                  class="w-full"
                ></nz-time-picker>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        @if (fncTypForm.status == 'INVALID' && shwErrMsg) {
        <div
          class="mt-3 p-2 bg-red-50 rounded-lg text-sm text-red-700 text-center"
        >
          Please fill required fields
        </div>
        }
      </form>
    </div>
    }
    <!-- Route Details -->
    @if (shwrtDtls) {
    <div class="bg-white rounded-xl shadow-sm border border-gray-100 p-4">
      <h2 class="text-base font-semibold text-gray-800 mb-3">Route Details</h2>
      <form nz-form [formGroup]="routeForm">
        <div formArrayName="routes" class="space-y-3">
          @for (r of routeForm.get('routes').controls; track r; let i = $index)
          {
          <div
            [formGroupName]="i"
            class="p-3 border border-gray-200 rounded-lg bg-gray-50"
          >
            <div class="flex items-center gap-2 mb-2">
              <span
                class="flex items-center justify-center w-6 h-6 bg-blue-500 text-white rounded-full text-xs font-semibold"
                >{{ i + 1 }}</span
              >
              <span class="text-xs font-medium text-gray-600">
                @if (i==0) {
                <span>Start Location</span>
                } @if (i>0 && i < routeForm.get('routes').controls.length-1) {
                <span>Intermediate Stop</span>
                } @if (i == routeForm.get('routes').controls.length-1) {
                <span>End Location</span>
                }
              </span>
            </div>
            <div nz-row [nzGutter]="12">
              <div nz-col nzSpan="12">
                <nz-select
                  nzShowSearch
                  nzAllowClear
                  nzPlaceHolder="Select Location"
                  formControlName="fnce_id"
                  (ngModelChange)="fnceSelected($event, i)"
                  class="w-full"
                >
                  @for (f of fnceFltrOptns; track f) {
                  <nz-option
                    [nzValue]="f.fnce_id"
                    [nzLabel]="f.fnce_nm"
                  ></nz-option>
                  }
                </nz-select>
              </div>
              @if (trp_typ_id==1000003) {
              <div nz-col nzSpan="5">
                <nz-time-picker
                  nzShowTime
                  formControlName="arvl_ts"
                  [nzFormat]="timeFormat"
                  [(ngModel)]="arvl_ts"
                  nzPlaceHolder="Arrival"
                  class="w-full"
                ></nz-time-picker>
              </div>
              } @if (trp_typ_id==1000003) {
              <div nz-col nzSpan="5">
                <nz-time-picker
                  nzShowTime
                  formControlName="dprtr_ts"
                  [nzFormat]="timeFormat"
                  [(ngModel)]="dprtr_ts"
                  nzPlaceHolder="Departure"
                  class="w-full"
                ></nz-time-picker>
              </div>
              }
              <div nz-col nzSpan="2" class="flex items-center gap-1">
                @if (i < routeForm.get('routes').controls.length-1) {
                <button
                  type="button"
                  (click)="addRoute(i, routeForm.controls.routes)"
                  nz-button
                  nzType="text"
                  nzSize="small"
                  class="text-green-600"
                >
                  <i nz-icon nzType="plus-square" nzTheme="outline"></i>
                </button>
                } @if (i>0 && i < routeForm.get('routes').controls.length-1) {
                <button
                  type="button"
                  (click)="deleteRoute(routeForm.controls.routes, i)"
                  nz-button
                  nzType="text"
                  nzSize="small"
                  class="text-red-600"
                >
                  <i nz-icon nzType="delete" nzTheme="outline"></i>
                </button>
                }
              </div>
            </div>
          </div>
          }
        </div>
        <div class="mt-4 flex items-center gap-2">
          @if (isAddTrip==true && !shwUpdtbtn) {
          <button
            nz-button
            nzType="primary"
            type="button"
            (click)="savetripRoute()"
          >
            <i nz-icon nzType="save" nzTheme="outline"></i> Save
          </button>
          } @if (shwUpdtbtn) {
          <button
            nz-button
            nzType="primary"
            type="button"
            (click)="updatetripRoute()"
          >
            <i nz-icon nzType="sync" nzTheme="outline"></i> Update
          </button>
          }
          <button
            nz-button
            nzType="default"
            type="button"
            (click)="resetrouteForm()"
          >
            <i nz-icon nzType="reload" nzTheme="outline"></i> Reset
          </button>
        </div>
      </form>
    </div>
    }
  </div>
  }
</div>

<!-- Add Location Slide-Over Panel (Tailwind CSS) -->
@if (opnSdebar && ShowAddFnce) {
<div class="fixed inset-0 z-50 overflow-hidden">
  <!-- Backdrop -->
  <div
    class="absolute inset-0 bg-gray-500 bg-opacity-50 transition-opacity"
    (click)="closeSider()"
  ></div>
  <!-- Slide-over panel -->
  <div class="fixed inset-y-0 right-0 flex max-w-full pl-10">
    <div class="w-screen max-w-lg">
      <div class="flex h-full flex-col bg-white shadow-2xl">
        <!-- Header -->
        <div class="bg-gradient-to-r from-green-600 to-teal-600 px-4 py-4">
          <div class="flex items-center justify-between">
            <h2 class="text-lg font-semibold text-white">Add Location</h2>
            <button
              type="button"
              (click)="closeSider()"
              class="rounded-md text-white hover:text-gray-200 focus:outline-none"
            >
              <svg
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
        <!-- Content -->
        <div class="flex-1 overflow-y-auto px-4 py-4">
          @if (tnt_id) {
          <app-location-add [tntId]="selctdtenant"></app-location-add>
          }
        </div>
      </div>
    </div>
  </div>
</div>
}
